import React, { Component } from "react";
import { trackPromise } from 'react-promise-tracker';
import PagoServiceServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";
import CuentaSocioTransferencia from "../../generico/CuentaSocioTransferencia";
import Popup from "react-popup";
import CabalTitulo from "./CabalTitulo"
import history from "../login/history";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
// import Select from "react-select";
// import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";

export default class SicoopPaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      montoCuenta: 0,
      optionsCuentas: [],
      itemSelected: [],
      cuentasOrigen: [],
      disableSgte: true,
      modalidadPago: { value: "-1", label: "--Seleccione--" },
      cuentaOrigenSelected : undefined,
      // itemTCOSelected: { value: "-1", label: "--Seleccione--" },
      // itemSelected: { value: "-1", label: "--Seleccione--" },
      options : undefined,
      tarjetaList : [],
      buscarTarjeta : undefined,
      buscarCuentas : undefined,
      buscar : undefined,
      // tipo : undefined,
      nroCuentaTarjeta : undefined
    };
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
              window.location.reload();
            },
          },
        ],
      },
    });

  componentDidMount() {

  }

  

  selectorValue = (dataFromChild, item) => {
    this.setState({
      cuentaOrigenSelected: dataFromChild,
      cuentaDebito: dataFromChild.ahorro,
      saldoActual: dataFromChild.saldoTotal,
      detalleCuenta: dataFromChild.ahorro + " " + dataFromChild.descripcion,
      itemSelected: item,
    });
    this.enableNext(dataFromChild.saldoTotal,this.state.modalidadPago.value,dataFromChild.ahorro);
  };


  montoValue = (dataFromChild) => {
    this.setState({
      monto: dataFromChild,
    });
  };

 

  getOptionsCuentas(item) {
    let options = [];

    for (let i = 0; i < item.length; i++) {
      options.push({
        value: item[i].ahorro,
        label:
          item[i].ahorro +
          "-" +
          item[i].descripcion +
          "-" +
          " Saldo: " +
          item[i].saldoTotal + " " +
          item[i].moneda +
          ".",
      });
    }
    this.setState({ optionsCuentas: options });
  }


  getCuentasSocio() {
    if( this.state.buscarCuentas === undefined ){
      trackPromise(
        PagoServiceServiceV2.getCuentasSocio()
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigo === '0') {
              this.setState({ cuentasOrigen: jsonData.resultadoAH , buscarCuentas : true });
              this.getOptionsCuentas(jsonData.resultadoAH);
            }
          },
          error => {
            const resMessage = error.codDescripcion;
            this.setState({
              loading: false,
              message: resMessage
            });
          }
      ));
    }
  }

  // getTarjetas() {
  //   if( this.state.buscarTarjeta === undefined ){

  //     this.state.buscarTarjeta = true;
  //     trackPromise(
  //       PagoServiceServiceV2.getTarjetasCabal().then((response) => {
          
  //         var resp = response.data;
  //         if (resp.codigoRetorno === "0") {
  //           if (resp.datos[0] !== null) {
  //             let options = [];
  //             let tarjetaList = [];
  //             for (let index = 0; index < resp.datos.length; index++) {
  //               //// filtra las tarjetas Master del listado
  //               let tipoTarjeta = this.obtenerTipoTarjeta(resp.datos[index].numeroTarjeta);
  //               // if (tipoTarjeta === "MASTER" || resp.datos[index].sucursal === 81) {
  //               //   continue;
  //               // }
  //               let tarjeta = {
  //                 id: resp.datos[index].numeroTarjeta,
  //                 detalle: resp.datos[index].numeroTarjeta,
  //                 tipo: tipoTarjeta,
  //                 saldo: resp.datos[index].limiteCompra,
  //                 moneda: "GS",
  //                 formaPago: "TARJETA",
  //                 codFormaPago: "TCO",
  //                 disponible: resp.datos[index].disponible,
  //                 sobregiro: resp.datos[index].sobregiro,
  //                 dispMasSobregiro: resp.datos[index].dispMasSobregiro
  //               }
  //               tarjetaList.push(tarjeta);
  //               var nro = resp.datos[index].numeroTarjeta;
  //               options.push({
  //                 value: resp.datos[index].numeroTarjeta,
  //                 label:
  //                 nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length) +
  //                   " - " +
  //                   tipoTarjeta +
  //                   " Disponible: " +
  //                   formatoSeparadorMilesValue(resp.datos[index].disponible) +
  //                   " " +
  //                   "GS" +
  //                   ".",
  //               });
  //             }
  //             this.setState({ tarjetaList: tarjetaList , options : options , buscarTarjeta : true });
  //           } else {
  //             this.notifiPopup("Atención", "Sin resultados");
  //           }

  //         } else {
  //           if (resp.codigoRetorno !== 401) {
  //             this.notifiPopup("Error", resp["mensajeRetorno"]);
  //           }
  //         }
          
  //       })
  //     ).catch(function (error) {
  //       console.log(error);
  //     });
  //   }
  // }

  obtenerTipoTarjeta(nroTarjeta) {
    var prefijo = nroTarjeta.substring(0, 4);
    if (prefijo === "5150" || prefijo === "5418" || prefijo === "5358" || prefijo === "5402") {
      return "MASTER";
    }
    if (prefijo === "6020") {
      return "PANAL";
    }
    if (prefijo === "5896" || prefijo === "6042") {
      return "CABAL";
    }
  }

  enableNext(monto , modalidadPago , numeroCuentaOtarjeta){
    if( this.state.cuentaOrigenSelected === undefined ){
      console.log('NO SE SELECCIONO NINGUNA CUENTA');
      this.setState({disableSgte:true});
    }
    // if( monto < (parseInt(this.props.comision)+parseInt(this.props.monto)) ){
    //   console.log('MONTO DE LA CUENTA MENOR AL MONTO A PAGAR');
    //   // Popup.queue(this.notifiPopup('Info','El monto que desae pagar es mayor a su disponible'));
    //   this.setState({disableSgte:true});
    //   return;
    // }
    // if( this.state.modalidadPago.value === '-1' ){
    //   console.log('MODALIDAD DE PAGO IGUAL A -1');
    //   this.setState({disableSgte : true});
    //   return;
    // }
    // if( this.state.modalidadPago.value === 'CCAHOO' ){
    //   if( numeroCuentaOtarjeta === undefined || numeroCuentaOtarjeta === '' ){
    //     console.log('CUENTA DE ORIGEN SELECCIONADO IGUAL A UNDEFINED');
    //     this.setState({disableSgte : true});
    //     return;
    //   }
      
    // } else{
    //   if( numeroCuentaOtarjeta === undefined || numeroCuentaOtarjeta === '' ){
    //     console.log('NUMERO DE CUENTA O TARJETA IGUAL A VACÍO');
    //     this.setState({disableSgte : true});
    //     return;
    //   }
    // }
    this.setState({disableSgte : false , nroCuentaTarjeta : numeroCuentaOtarjeta});
  }

  detalles() {
    if( this.state.buscar === undefined ){
      this.getCuentasSocio();
      if( this.state.tarjetaList.length !== 0 && this.state.optionsCuentas.length !== 0 )
        this.setState({buscar : this.props.buscar});
    }
  }

  validarPaso3 = (e) => {
    if (this.props.paso2 !== undefined && this.props.paso1 !== undefined) {
      this.props.respuestaPaso3(this.state.cuentaOrigenSelected, null, this.props.paso2);
    }
    if (this.props.paso1 !== undefined && this.props.paso2 === undefined) {
      this.props.respuestaPaso3(this.state.cuentaOrigenSelected, null, this.props.paso1);
    }
    this.step3.click();
  };

  handleEnter(e) {
    if(e.keyCode === 13) {
      e.preventDefault();
    }
  }

  volver = (e) => {
    this.setState({ optionsCuentas: [], cuentaOrigenSelected: [] });
    if (this.props.paso2 !== null && this.props.paso1 !== null) {
      this.step2.click();
    }
    if (this.props.paso1 !== null && this.props.paso2 === undefined) {
      this.step1.click();
    }
  };

  volverPagoServicio = (e) => {
    history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
    window.location.reload();
  }

  render() {
    if (this.props.currentStep !== 3) { // Prop: The current step
      return null;
    }
    if (this.props.currentStep === 3) {
      this.detalles();
    }
    return (
      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <div className="steps clearfix" style={{ marginBottom: 5 }}>
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">{this.props.nombre}</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="number">5</span>
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <CabalTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr />

        {/******************* LOGICA PASOS ***********************/}
        <form id="idSicoopPaso3" onSubmit={(e) => e.preventDefault()} onKeyDown={this.handleEnter}>
       
          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <div className="form-group">
                <CuentaSocioTransferencia
                  selectorValue={this.selectorValue.bind(this)}
                  operacion='DEBITO'
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  itemSelected={this.state.itemSelected}
                  montoValue = {this.montoValue.bind(this)}
                />
              </div>
              {/* <CuentaSocioTransferencia
                renderMonto="false"
                selectorValue={this.selectorValue.bind(this)}
                montoValue={this.montoValue.bind(this)}
                operacion="DEBITO"
                tipoCuenta="AHORRO_VISTA"
                items={this.state.cuentasOrigen}
                monto={this.state.monto}
                itemSelected={this.state.itemSelected}
              /> */}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4 btn-consulta">
            <button className="btn btn-cu-secundary" onClick={this.volverPagoServicio}><FontAwesomeIcon icon={faMoneyCheckDollar} /> Pagar Otro Servicio</button>
            </div>
            <div className="col-md-4 btn-consulta">
            <button className="btn btn-cu-quintary" onClick={this.volver} ><FontAwesomeIcon icon={faArrowLeft} /> Volver</button>
            </div>
            <div className="col-md-4">
              <button disabled={this.state.disableSgte} id="btn-next-paso3" className="btn btn-cu-primary" onClick={this.validarPaso3}>Continuar <FontAwesomeIcon icon={faArrowRight} /> </button>
              
            </div>
          </div>

          <button
            hidden
            ref={(a) => (this.step3 = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
            disabled = {this.state.disableSgte}
          ></button>
          <button
            hidden
            ref={(a) => (this.step2 = a)}
            className="btn btn-cu-primary"
            onClick={this.props.previousStep}
          ></button>
          <button
            hidden
            ref={(a) => (this.step1 = a)}
            className="btn btn-cu-primary"
            onClick={() => this.props.goToStep(1)}
          ></button>
        </form>
      </div>
    );
  }
}